import React from "react";
import API from "../../services/api.jsx";
import Loader from "../layout/loader.jsx";
import Head from "../layout/head.jsx";
import Content from "../layout/content.jsx";
import Table from "../layout/table.jsx";
import { toast } from "react-toastify";
import { debounce } from "lodash";
import Helpers from "../../services/helpers.jsx";

class AffiliatesList extends React.PureComponent {
  constructor(props) {
    super(props);

    const columns = [
      {
        label: "Affiliate name",
        key: "name",
      },
      {
        label: "Users",
        key: "users",
      },
      {
        label: "Clients",
        key: "clients",
      },
      {
        label: "Playlists",
        key: "playlists",
      },
      {
        label: "Collections",
        key: "collections",
      },
    ];
    if (Helpers.checkPermissions("affiliates:delete")) {
      columns.push({
        action: "delete",
        onClick: (id, rowKey, entity) => {
          if (
            entity?.users ||
            entity?.playlists ||
            entity?.collections ||
            entity?.clients
          ) {
            toast.error(
              "This affiliate has already some items assigned to it, you cannot delete it. Please change the affiliate of all corresponding items first before deleting it."
            );
            return;
          }
          var r = window.confirm(
            `Are you sure you want to delete this Affiliate[${entity?.name}]?`
          );
          if (r === false) return;

          this.setState({ loading: true });
          API.delete("affiliates", id)
            .then(() => {
              toast.success("Affiliate was successfully deleted");
              this.loadEntities();
            })
            .catch((err) => {
              toast.success(err.message || "An unexpected error has occurred");
              this.setState({ loading: false });
            });
        },
      });
    }

    const actions = [];
    if (Helpers.checkPermissions("affiliates:edit")) {
      actions.push({
        classList: "blue add",
        label: "New affiliates",
        onClick: () => this.props.history.push("/affiliates/new"),
      });
    }

    this.state = {
      clients: [],
      loading: true,
      search: "",
      filters: {},
      sort: ["name", "ASC"],
      tabs: {},
      affiliates: {
        columns,
        entities: [],
        filters: [
          {
            label: "Search for a campaign",
            onChange: debounce((value) => {
              if (value !== this.state.filters.name) {
                const newFilter = Helpers.cleanObject({
                  ...this.state.filters,
                  q: value,
                });
                this.setState({ filters: newFilter }, () => {
                  this.loadEntities();
                });
              }
            }, 500),
          },
        ],
        actions,
        selectedItems: [],
        multiSelect: false,
        onRowClick: (entity) => {
          if (
            Helpers.checkPermissions(
              ["affiliates:details", "affiliates:edit"],
              true
            )
          ) {
            this.props.history.push(`/affiliates/${entity.id}/edit`);
          }
        },
      },
    };
  }

  componentDidMount() {
    this.loadEntities();
  }

  onSort(key) {
    const newSort =
      this.state?.sort?.[0] === key
        ? this.state?.sort?.[1] === "ASC"
          ? [key, "DESC"]
          : [key, "ASC"]
        : [key, "ASC"];
    this.setState(
      {
        sort: newSort,
      },
      () => {
        this.loadEntities();
      }
    );
  }

  loadEntities() {
    API.getAffiliates(this.state.filters, this.state.sort).then((entities) => {
      const filters = [];
      if (entities?.filters?.availableFilters) {
        Helpers.handleFilters(this, filters, entities);
      }

      this.setState({
        ...this.state,
        affiliates: {
          ...this.state.affiliates,
          filters,
          entities: entities?.data || [],
        },
        loading: false,
      });
    });
  }

  render() {
    if (this.state.loading) return <Loader />;
    else
      return (
        <>
          <Head title={"Affiliates"} tabs={this.state.tabs} />
          <Content>
            <Table
              settings={this.state.affiliates}
              loadEntities={this.loadEntities}
              sort={this.state.sort}
            />
          </Content>
        </>
      );
  }
}

export default AffiliatesList;
